import { AppSetting, persistOverriddenSettings } from 'app/infrastructure/hosting/app-settings';

// TODO: Workaround since we do not have independent variables per application in our deployments
AppSetting.ApplicationUrl = AppSetting.AnonymousApplicationUrl;
AppSetting.ApiBaseUrl = AppSetting.AnonymousApiBaseUrl;

export { AppSetting, persistOverriddenSettings };
